import type { TranslationKeys } from "./id";

const en: TranslationKeys = {
	common: {
		batal: "Cancel",
		simpan: "Save Changes",
		simpanPreferensi: "Save Preferences",
		berhasilDisimpan: "Preferences saved successfully",
		gagalMuat: "Failed to load preferences",
		gagalSimpan: "Failed to save preferences",
		berhasil: "Success",
		kesalahan: "Error",
		administrator: "Administrator",
		pengguna: "User",
		wallNoc: "NOC Wall",
	},
	breadcrumb: {
		home: "Desa Darmasaba",
		kinerjaDevisi: "Division Performance",
		pengaduanLayanan: "Complaints & Public Services",
		jennaAnalytic: "Jenna Analytics",
		demografi: "Demographics & Population",
		keuangan: "Finance & Budget",
		bumdes: "Bumdes & Village UMKM",
		sosial: "Social",
		keamanan: "Security",
		bantuan: "Help",
		pengaturan: "Settings",
		umum: "General",
		notifikasi: "Notifications",
		aksesDanTim: "Access & Team",
		sinkronisasi: "NOC Sync",
		profile: "Profile",
		edit: "Edit",
	},
	sidebar: {
		cariApaSaja: "search anything",
		perlebarMenu: "Expand menu",
		beranda: "Home",
		kinerjaDevisi: "Division Performance",
		pengaduanLayanan: "Complaints & Public Services",
		analitik: "Jenna Analytics",
		demografi: "Demographics & Population",
		keuangan: "Finance & Budget",
		bumdes: "Bumdes & Village UMKM",
		sosial: "Social",
		keamanan: "Security",
		bantuan: "Help",
		pengaturan: "Settings",
		settingsUmum: "General",
		settingsNotifikasi: "Notifications",
		settingsKeamanan: "Security",
		settingsAksesTim: "Access & Team",
		settingsSinkronisasi: "NOC Sync",
	},
	umum: {
		judulTampilan: "Display Preferences",
		judulDashboard: "Dashboard",
		bahasaAplikasi: "Application Language",
		zonaWaktu: "Time Zone",
		formatTanggal: "Date Format",
		refreshOtomatis: "Auto Refresh",
		intervalRefresh: "Refresh Interval",
		tampilkanGrid: "Show Grid",
		animasiTransisi: "Transition Animation",
	},
	notifikasi: {
		metodeNotifikasi: "Notification Methods",
		preferensiAlert: "Alert Preferences",
		notifikasiPush: "Push Notifications",
		laporanHarian: "Daily Report",
		alertSistem: "System Alert",
		updateKeamanan: "Security Update",
		newsletterBulanan: "Monthly Newsletter",
		tresholdMemori: "Memory Threshold",
		tresholdCpu: "CPU Threshold",
		tresholdDisk: "Disk Threshold",
		alertKritis: "Critical Alert",
		aktivitasTim: "Team Activity",
		komentarMention: "Comments & Mentions",
		bunyiNotifikasi: "Notification Sound",
	},
	keamanan: {
		autentikasi: "Authentication",
		password: "Password",
		auditLog: "Audit & Log",
		twoFactor: "Two-Factor Authentication",
		biometrikLogin: "Biometric Login",
		ipWhitelist: "IP Whitelist",
		logAktivitas: "Activity Log",
		riwayatLogin: "Login History",
		perangkatTerdaftar: "Registered Devices",
		downloadLog: "Download Log",
		cctvAktif: "Active CCTV",
		kameraOnline: "Online Cameras",
		laporanKeamanan: "Security Reports",
		mingguIni: "This week",
		petaKeamananCctv: "CCTV Security Map",
		titikLokasiCctv: "CCTV Location Points",
		kamera: "cameras",
		daftarCctv: "CCTV List",
		belumAdaDataCctv: "No CCTV data available",
		laporanPublik: "Public Reports",
		belumAdaLaporanKeamanan: "No security reports yet",
	},
	akses: {
		manajemenTim: "Team Management",
		hakAkses: "Access Rights",
		kolaborasi: "Collaboration",
		undanganAnggota: "Invite New Member",
		kelolaRole: "Manage Roles & Permissions",
		daftarAnggotaAktif: "Most Active Members",
		administrator: "Administrator",
		editor: "Editor",
		viewer: "Viewer",
		orang: "People",
		anggota: "Members",
		izinExport: "Data Export Permission",
		requireApproval: "Require Approval for Changes",
	},
	dashboard: {
		suratMingguIni: "Letters This Week",
		totalSuratDiajukan: "Total letters submitted",
		pengaduanAktif: "Active Complaints",
		baru: "new",
		diproses: "in progress",
		ditolak: "Rejected",
		layananSelesai: "Completed Services",
		totalDiselesaikan: "Total completed",
		totalPenduduk: "Total Residents",
		kepalaKeluarga: "Households",
		kalenderKegiatan: "Calendar & Upcoming Events",
		tidakAdaKegiatan: "No upcoming events",
		realisasiLabel: "Realization",
		anggaranLabel: "Budget",
		status100: "Realization reached 100% of budget",
		statusBaik: "Good realization, close to target",
		statusCukup: "Moderate realization, needs improvement",
		statusRendah: "Low realization, needs special attention",
		tidakAdaDataApbdes: "No APBDes data available",
		statistikSurat: "Letter Submission Statistics",
		trendSurat: "Letter submission trend over the last 6 months",
		tampilkanDetail: "Show Details",
		tidakAdaDataSurat: "No letter submission data for the last 6 months",
		divisiTeraktif: "Most Active Divisions",
		kegiatan: "Activities",
		tidakAdaDataDivisi: "No division data available",
		tingkatKepuasan: "Satisfaction Level",
		tingkatKepuasanSubtitle: "Service satisfaction rate",
		sangatPuas: "Very Satisfied",
		puas: "Satisfied",
		cukup: "Moderate",
		kurang: "Unsatisfied",
	},
	sinkronisasi: {
		judul: "Data Synchronization",
		deskripsi:
			"Use this feature to update dashboard data with the latest data from the source server.",
		dataNoc: "NOC Data (muku.id)",
		websiteDesa: "Village Website (darmasaba.desa.id)",
		informasiSumber: "Data Source Information",
		statusTerakhir: "Last Status",
		waktuSinkronisasi: "Last Sync Time:",
		terkoneksi: "Connected",
		belumPernah: "Never Synced",
		belumPernahDilakukan: "Never done",
		sinkronkanNoc: "Sync NOC",
		sinkronkanDesa: "Sync Village Website",
		tidakAdaAkses:
			"You don't have access. Make sure you are logged in as admin.",
		gagalSinkronisasi: "Sync failed. Check console for details.",
		sinkronisasiBerhasil: "Synchronization completed successfully",
		responseGagal: "Unrecognized response from server",
		kesalahanSistem:
			"System error during synchronization. Check console for details.",
		gagalDemografi: "Failed to sync demographic data.",
		berhasilDemografi: "Demographic data sync completed successfully",
		kesalahanDemografi: "System error during demographic data synchronization.",
		model: "Model:",
		url: "URL:",
		nocNama: "Network Operation Center (NOC)",
		desaNama: "Darmasaba Village Website",
	},
	kinerjaDivisi: {
		statusSelesai: "Completed",
		statusBerjalan: "In Progress",
		statusTertunda: "Pending",
		tidakAdaAktivitas: "No recent activities",
		diskusi: "Discussion",
		tidakAdaDiskusi: "No discussions",
		jumlahDokumen: "Document Count",
		tidakAdaDokumen: "No documents",
		acaraHariIni: "Today's Events",
		tidakAdaAcara: "No events today",
		progresKegiatan: "Activity Progress",
		divisiTeraktif: "Most Active Divisions",
		tidakAdaDataDivisi: "No division data available",
		progres: "Progress",
	},
	pengaduanLayanan: {
		totalPengaduan: "Total Complaints",
		bulanIni: "This month",
		baru: "New",
		belumDiproses: "Unprocessed",
		diproses: "In Process",
		sedangDitangani: "Being handled",
		selesai: "Completed",
		terselesaikan: "Resolved",
		ditolak: "Rejected",
		tidakDitindaklanjuti: "Not followed up",
		trenPengaduan: "Complaint Trends",
		tidakAdaDataPengaduan: "No complaint data for the last 7 months",
		suratTerbanyak: "Most Requested Letters",
		pengajuanTerbaru: "Recent Submissions",
		tidakAdaPengajuan: "No recent submissions",
		ajuanIdeInovatif: "Musrenbang",
		tidakAdaIde: "No innovative ideas",
		detail: "Details",
		detailIde: "Innovation Idea Details",
		deskripsiIde: "Idea Description",
		pengusul: "Submitter",
		kontakPengusul: "Contact",
		diajukanPada: "Submitted On",
		kategoriIde: "Category",
		tidakAdaKontak: "No contact provided",
		tutupIde: "Close",
	},
	bumdes: {
		vsBulanLalu: "vs last month",
		updatePenjualan: "Product Sales Update",
		mingguIni: "This week",
		bulanIni: "This month",
		totalPenjualan: "Total Sales",
		kategoriSuffix: "categories",
		produkAktif: "Active Products",
		totalTransaksi: "Total Transactions",
		transaksiSuffix: "transactions",
		umkmAktif: "Active UMKM",
		beroperasi: "Operating",
		umkmTerdaftar: "Registered UMKM",
		totalRegistrasi: "Total registrations",
		omzet: "Revenue",
		omzetBumdes: "BUMDes monthly revenue",
		umkmTerbanyak: "Top UMKM",
		kategoriPrefix: "Category",
		top3Produk: "Top 3 Best Selling Products",
		tidakAdaProdukTerlaris: "No best selling product data available",
		terjual: "sold",
		detailPenjualan: "Product Sales Detail",
		semuaKategori: "All Categories",
		semuaUmkm: "All UMKM",
		produk: "Product",
		penjualanBulanIni: "This Month's Sales",
		bulanLalu: "Last Month",
		trend: "Trend",
		volume: "Volume",
		stok: "Stock",
		aksi: "Action",
		stokAman: "Safe",
		stokSedang: "Medium",
		stokRendah: "Low",
		detail: "Detail",
		detailProduk: "Product Detail",
		perubahan: "Change",
		statusStok: "Stock Status",
		perbandinganPenjualan: "Sales Comparison",
		tutupDetail: "Close",
		infoVolume: "Sales Volume",
	},
	keuanganAnggaran: {
		totalApbdes: "Total APBDes",
		tahun: "Year",
		realisasi: "Realization",
		dari: "of",
		pemasukan: "Income",
		totalRealisasi: "Total Realization",
		pengeluaran: "Expenses",
		jan: "Jan",
		feb: "Feb",
		mar: "Mar",
		apr: "Apr",
		mei: "May",
		jun: "Jun",
		jul: "Jul",
		agu: "Aug",
		sep: "Sep",
		okt: "Oct",
		nov: "Nov",
		des: "Dec",
		pemasukanDanPengeluaran: "Income & Expenses (M)",
		alokasiAnggaran: "Budget Allocation by Sector (M)",
		jumlah: "Amount",
		laporanApbdes: "APBDes Report",
		pendapatan: "Revenue",
		belanja: "Expenditure",
		total: "Total:",
		saldo: "Balance:",
		totalAnggaran: "Total budget:",
		realisasiLaporan: "Realization",
		saldoAnggaran: "Budget balance:",
		saldoRealisasi: "Realization balance:",
		danaBantuan: "Grants & Aid Funds",
		cair: "Disbursed",
		proses: "Processing",
		tidakAdaBantuan: "No grants or aid data found",
	},
	demografiPekerjaan: {
		totalPenduduk: "Total Population",
		aktifTerdaftar: "Registered active",
		kepalaKeluarga: "Head of Household",
		totalKk: "Total Households",
		kelahiran: "Births",
		tahunIni: "This year",
		kemiskinan: "Poverty",
		keluargaPrasejahtera: "Low-income Families",
		kematian: "Deaths",
		pindahMasuk: "Move In",
		pindahKeluar: "Move Out",
		pertumbuhanAlami: "Natural growth",
		pertumbuhanAlamiKeterangan: "births − deaths",
		migrasiBersih: "Net migration",
		migrasiBersihKeterangan: "move in − move out",
		perubahanTotal: "Total change",
		pengelompokanUmur: "Age Groups",
		demografiPekerjaan: "Occupation Demographics",
		dinamikaPenduduk: "Population Dynamics",
		distribusiAgama: "Religion Distribution",
		dataPerBanjar: "Data by Banjar",
		sektorUnggulan: "Leading Sectors",
		banjar: "Banjar",
		penduduk: "Population",
		kk: "Households",
		miskin: "Poor",
	},
	jennaAnalytic: {
		interaksiHariIni: "Today's Interactions",
		plusDariKemarin: "+15% from yesterday",
		jawabanOtomatis: "Automatic Answers",
		dari61Interaksi: "53 of 61 interactions",
		belumDitindak: "Unhandled",
		perluResponManual: "Needs manual response",
		waktuRespon: "Response Time",
		rataRata: "Average",
		sen: "Mon",
		sel: "Tue",
		rab: "Wed",
		kam: "Thu",
		jum: "Fri",
		sab: "Sat",
		min: "Sun",
		topikKtp: "How to get an ID card",
		topikKk: "Family Card Requirements",
		topikPosyandu: "Posyandu Schedule",
		topikJalan: "Road damage complaints",
		topikBansos: "Social assistance program info",
		pagiJam: "Morning (08–12)",
		siangJam: "Noon (12–16)",
		soreJam: "Afternoon (16–20)",
		malamJam: "Night (20–08)",
		interaksiChatbot: "Chatbot Interactions",
		topikPertanyaan: "Most Asked Questions",
		jamTersibuk: "Peak Hours",
	},
	sosial: {
		ibuHamilAktif: "Active Pregnant Mothers",
		aktif: "Active",
		balitaTerdaftar: "Registered Toddlers",
		terdaftar: "Registered",
		alertStunting: "Stunting Alert",
		perhatian: "Needs Attention",
		posyanduAktif: "Active Posyandu",
		statistikKesehatan: "Health Statistics",
		imunisasiLengkap: "Complete Immunization",
		pemeriksaanRutin: "Routine Check-up",
		giziBaik: "Good Nutrition",
		targetStunting: "Stunting Target",
		jadwalPosyandu: "Posyandu Schedule",
		pendidikan: "Education",
		jumlahLembagaPendidikan: "Educational Institutions",
		jumlahTenagaPengajar: "Teaching Staff",
		kesejahteraanMasyarakat: "Community Welfare",
		kesejahteraanKosong: "No welfare programs yet",
		beasiswaDesa: "Village Scholarship",
		penerima: "Recipients",
		danaTersalurkan: "Disbursed Funds",
		tahunAjaran: "Academic Year",
		lakiLaki: "Male",
		perempuan: "Female",
		periode: "Period",
		kalenderEventBudaya: "Cultural Event Calendar",
		eventBudaya1Nama: "Pancasila Sanctity Day",
		eventBudaya1Tanggal: "October 1, 2025",
		eventBudaya1Lokasi: "Village Hall",
		eventBudaya2Nama: "Village Cultural Festival",
		eventBudaya2Tanggal: "May 20, 2026",
		eventBudaya2Lokasi: "Village Field",
		eventBudaya3Nama: "Village Anniversary Celebration",
		eventBudaya3Tanggal: "August 17, 2026",
		eventBudaya3Lokasi: "Village Hall",
	},
	help: {
		pusatBantuan: "Help Center",
		subtitle: "Find answers to your questions or contact our support team",
		artikelPanduan: "Guide Articles",
		videoTutorial: "Video Tutorial",
		supportAktif: "Active Support",
		panduanMemulai: "Getting Started",
		faq: "FAQ",
		hubungiSupport: "Contact Support",
		dokumentasi: "Documentation",
		emailLabel: "Email",
		whatsappLabel: "WhatsApp",
		jamKerjaLabel: "Working Hours",
		waktuResponLabel: "Response Time",
		tutup: "Close",
		durasi: "Duration",
		panduanBadge: "Guide",
		guideCaraLoginTitle: "How to Login",
		guideCaraLoginDesc: "Steps to log in to the dashboard",
		guideCaraLoginContent: `1. Open your browser and access the village dashboard URL.\n2. Enter your email and password on the login form.\n3. Click the "Login" button to continue.\n4. If successful, you will be redirected to the main dashboard page.\n5. If you forgot your password, click "Forgot Password" and follow the instructions sent to your email.`,
		guideNavTitle: "Dashboard Navigation",
		guideNavDesc: "Explanation of layout and navigation",
		guideNavContent:
			"1. The left sidebar contains the main menu: Home, Division Performance, Public Services, Demographics, Finance, and Settings.\n2. The top header shows the username, notifications, and logout button.\n3. The main area (center content) displays data based on the selected menu.\n4. Use the breadcrumb above the content to know your page position.\n5. On mobile devices, the sidebar can be opened/closed via the menu icon (hamburger) in the header.",
		guideFiturTitle: "Basic Features",
		guideFiturDesc: "Guide to using main features",
		guideFiturContent:
			"1. Home: Displays village statistics summary, recent activities, and main charts.\n2. Division Performance: Monitor activities, documents, and discussions per division.\n3. Public Services: Manage complaint letters and public service letters.\n4. Demographics: View population data, banjar, health, and employment.\n5. Finance & UMKM: Monitor village budget and UMKM list.\n6. Settings: Manage user profile and system configuration.",
		guideTipsTitle: "Tips & Tricks",
		guideTipsDesc: "Tips to improve productivity",
		guideTipsContent:
			"1. Use keyboard shortcuts for faster navigation in data tables.\n2. Filters and search are available on every list page — use them to find specific data.\n3. Export data to CSV/Excel with the Export button on the table page for offline reports.\n4. Enable dark mode in Settings for comfortable late-night work.\n5. Manually refresh data with the reload button if data appears out of sync with the central system.\n6. Use the Jenna (Virtual Assistant) feature on this page for quick help.",
		videoDashboardTitle: "Dashboard Overview",
		videoAnalisisTitle: "Data Analysis",
		videoLaporanTitle: "Creating Reports",
		videoExportTitle: "Export Data",
		faqQ1: "How to reset password?",
		faqA1: `You can reset your password via the login page by clicking "Forgot Password"`,
		faqQ2: "Can I access data offline?",
		faqA2: "Currently the application can only be accessed online",
		faqQ3: "How long does support take to respond?",
		faqA3: "Our support team usually responds within 24 hours",
		faqQ4: "How to add a new user?",
		faqA4:
			"The user addition feature can be found in Settings > User Management",
		docApiTitle: "API Reference",
		docApiDesc: "Complete documentation for API integration",
		docIntegrasiTitle: "System Integration",
		docIntegrasiDesc: "How to integrate with external systems",
		docFormatTitle: "Data Format",
		docFormatDesc: "Supported data format specifications",
		docBestTitle: "Best Practices",
		docBestDesc: "Best practices for using the platform",
		jamKerjaValue: "Monday - Friday, 09:00 - 17:00 WIB",
		waktuResponValue: "Average 2-4 working hours",
		docApiContent: `GET /api/demografi/summary\ncurl -H "Authorization: Bearer <token>" \\\n  https://dashboard-desa-plus-stg.wibudev.com/api/demografi/summary\nResponse: {"totalPenduduk": 5234, "lakiLaki": 2617, "perempuan": 2617}\n\nGET /api/complaint/stats\ncurl -H "Authorization: Bearer <token>" \\\n  https://dashboard-desa-plus-stg.wibudev.com/api/complaint/stats\nResponse: {"total": 42, "selesai": 30, "proses": 8, "pending": 4}\n\nGET /api/umkm/summary\ncurl -H "Authorization: Bearer <token>" \\\n  https://dashboard-desa-plus-stg.wibudev.com/api/umkm/summary\nResponse: {"totalUmkm": 87, "aktif": 72, "nonaktif": 15}`,
		docIntegrasiContent: `1. Authentication: Use JWT token or session cookie. Get the token via POST /api/auth/login with email & password.\n2. Base URL per environment:\n   - Staging: https://dashboard-desa-plus-stg.wibudev.com/api\n   - Production: https://dashboard-desa-plus.wibudev.com/api\n3. Required headers:\n   - Content-Type: application/json\n   - Authorization: Bearer <token>\n4. Example request from external system:\n   curl -X POST https://dashboard-desa-plus-stg.wibudev.com/api/complaint \\\n     -H "Content-Type: application/json" \\\n     -H "Authorization: Bearer eyJhbGciOiJIUzI1NiIs..." \\\n     -d '{"title": "Damaged Road Report", "description": "Road in Banjar Kaja has potholes"}'`,
		docFormatContent: `Date       : ISO 8601 (YYYY-MM-DD), example: 2026-05-08\nTime       : HH:mm:ss WIB, example: 14:30:00 WIB\nCurrency   : IDR without decimals, example: 15000000\nCoordinates: Decimal Latitude/Longitude, example: -8.12345, 115.12345\nStatus Enum:\n  - AKTIF / NONAKTIF\n  - NORMAL / ALERT / STUNTING`,
		docBestContent: `• Use pagination (?page=&limit=) to fetch large datasets\n• Avoid polling intervals < 30 seconds to reduce server load\n• Cache responses client-side for data that rarely changes\n• Use period filters (startDate/endDate) for large queries\n• Never expose API keys in the frontend — always use tokens from the server`,
		kontakDukungan: "Contact Support",
		formNama: "Full Name",
		formEmail: "Email",
		formKategori: "Problem Category",
		formDeskripsi: "Problem Description",
		formScreenshot: "Screenshot (optional)",
		formScreenshotHint: "Max 2MB, PNG/JPG format",
		kirimTiket: "Send Ticket",
		tiketTerkirim:
			"Ticket sent successfully! Our team will contact you shortly.",
		tiketGagal: "Failed to send ticket. Please try again later.",
		infoKontak: "Village Contact Info",
		jamOperasionalLabel: "Operating Hours",
	},
};

export default en;
